export const getNavBarItems = (t) => [
  {
    key: t("nav.domov"),
    url: "/",
  },
  {
    key: t("nav.meni"),
    url: "/meni",
  },
  {
    key: t("nav.gostisce"),
    url: "/gostisce",
  },
  {
    key: t("nav.okolica"),
    url: "/okolica",
  },
  {
    key: t("nav.galerija"),
    url: "/galerija",
  },
];
